import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';

export const googleBigQueryObjectMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.googleBigQuery.datasetType,
    disabled: __IS_FABRIC_DPE__,
    displayName: getConnectorLegacyNameByFlag(stringResources.GoogleBigQuery_DisplayText, true),
    supportLinkedServiceTypes: [adfModelTypeMap.googleBigQuery.linkedServiceType],
    warningMessage: format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt2,
        stringResources.DatasetLowerCase,
        stringResources.GoogleBigQuery_DisplayText
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-google-bigquery?tabs=data-factory',
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-google_bigquery'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    schemaAlias: 'dataset',
    category: ['Database']
};
